export default __webpack_public_path__ + "assets/429bf2.svg";